import { render } from "./FloatingButtons.vue?vue&type=template&id=710ffa67&scoped=true"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"

import "./FloatingButtons.vue?vue&type=style&index=0&id=710ffa67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710ffa67"]])

export default __exports__